import React, { Component } from 'react'
import moment from 'moment';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { development } from "../../libs/utils/Const";

class PaymentsReceived extends Component {

    render() {
        return (
            <div className='mt-5' style={{height :"auto", width:"90%", marginLeft: "auto", marginRight:"auto", marginBottom: "100px"}}>
                {/* aqiui */}
                <div className="row">
                    <div className="col-3">
                        <img src={development? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />
                        <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /><strong>{Datos_Empresa.RFC}</strong></p>
                        <span className="text-left">Teléfono(s):</span>
                        <p>COL. C.P.;,.</p>
                    </div>
                    <div className="col-9"></div>
                </div>
                <div className='row mt-4' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead >
                            <tr>
                                <th className="text-right" colSpan="2">FECHA: 2022-06-30T18:34:42</th>
                            </tr>
                        </thead>
                        
                    </table>
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2">MOVIMIENTOS</th>
                            </tr>
                        </thead>
                        
                    </table>
                    
                    <table className='mt-2'>
                        <thead >
                            <tr>
                                <th className="text-left" colSpan={4}>Devolución</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Devolución</td>
                                <td className="text-center">efectivo</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Devolución</td>
                                <td className="text-center">Tarjeta de credito</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Devolución</td>
                                <td className="text-center">efectivo</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Devolución</td>
                                <td className="text-center">DEVOLUCIÓN</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                        </tbody>
                    </table>
                    <table className='mt-2'>
                        <thead >
                            <tr>
                                <th className="text-left" colSpan={4}>Venta</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Venta</td>
                                <td className="text-center">efectivo</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Venta</td>
                                <td className="text-center">efectivo</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Venta</td>
                                <td className="text-center">Tarjeta de credito</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Venta</td>
                                <td className="text-center">DEVOLUCIÓN</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='row mt-3'>
                    <div className='col-9'>
                        
                    </div>
                    <div className='col-3'>
                        <table>

                            <tbody>
                                <tr>
                                    <td className='text-right'><strong>Pago a cuenta: </strong></td>
                                    <td className='text-right mr-2'>0.00</td>
                                </tr>
                                <tr>
                                    <td className='text-right'><strong>Saldo vencido: </strong></td>
                                    <td className='text-right mr-2'>0.00</td>
                                </tr>
                                <tr>
                                    <td className='text-right'><strong>Total: </strong></td>
                                    <td className='text-right mr-2'>75.41</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='row mt-4' style={{ paddingRight: "15px" }}>
                    
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2">DETALLE DE FORMAS DE PAGO</th>
                            </tr>
                        </thead>
                        
                    </table>
                    
                    <table className='mt-2'>
                        <thead >
                            <tr>
                                <th className="text-left" colSpan={4}>Efectivo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Devolución</td>
                                <td className="text-center">efectivo</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Devolución</td>
                                <td className="text-center">Tarjeta de credito</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Devolución</td>
                                <td className="text-center">efectivo</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Devolución</td>
                                <td className="text-center">DEVOLUCIÓN</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                        </tbody>
                    </table>
                    <table className='mt-2'>
                        <thead >
                            <tr>
                                <th className="text-left" colSpan={4}>Tarjeta de credito</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Venta</td>
                                <td className="text-center">efectivo</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Venta</td>
                                <td className="text-center">efectivo</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Venta</td>
                                <td className="text-center">Tarjeta de credito</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Venta</td>
                                <td className="text-center">DEVOLUCIÓN</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                        </tbody>
                    </table>
                    
                </div>
                <div className='row mt-3'>
                    <div className='col-9'>
                        
                    </div>
                    <div className='col-3'>
                        <table>

                            <tbody>
                                <tr>
                                    <td className='text-right'><strong>Pago a cuenta: </strong></td>
                                    <td className='text-right mr-2'>0.00</td>
                                </tr>
                                <tr>
                                    <td className='text-right'><strong>Saldo vencido: </strong></td>
                                    <td className='text-right mr-2'>0.00</td>
                                </tr>
                                <tr>
                                    <td className='text-right'><strong>Total: </strong></td>
                                    <td className='text-right mr-2'>75.41</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='row mt-4' style={{ paddingRight: "15px" }}>
                    
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2">DETALLE DE SALIDA DE DINERO</th>
                            </tr>
                        </thead>
                        
                    </table>
                    
                    <table className='mt-2'>
                        
                        <tbody>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Devolución</td>
                                <td className="text-center">efectivo</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Devolución</td>
                                <td className="text-center">Tarjeta de credito</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Devolución</td>
                                <td className="text-center">efectivo</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                            <tr>
                                <td className="text-center">01</td>
                                <td className="text-center">Devolución</td>
                                <td className="text-center">DEVOLUCIÓN</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                        </tbody>
                    </table>
                    
                </div>
                <br />
                <br />
                <br />
            </div>
        )
    }
}

export default PaymentsReceived